import Backbone from 'backbone'
import _ from 'underscore'
import PageNavViewTemplate from '../templates/page-nav.tpl'
import titles from '../titles'
import config from '../config'

const PageNavView = Backbone.View.extend({
    tagName: 'div',
    id: 'page-nav-view',
    events: {
        'click .previous': 'previous',
        'click .next': 'next',
    },
    previousModel: null,
    nextModel: null,
    initialize() {
        this.template = _.template(PageNavViewTemplate)
        this.previousModel = titles.previous(this.model)
        this.nextModel = titles.next(this.model)
    },
    render() {
        this.$el.html(this.template({
            previous_model: this.previousModel,
            next_model: this.nextModel
        }))
        return this
    },
    previous() {
        const image_prefix = this.previousModel.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/content/${image_prefix}`, { trigger: true })
    },
    next() {
        const image_prefix = this.nextModel.get('image_prefix')
        const slug = config.get('slug')
        Backbone.history.navigate(`app/${slug}/content/${image_prefix}`, { trigger: true })
    },
})

export default PageNavView

